import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsSection } from './components/StatsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSolutionSection } from './components/PainSolutionSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { LivePopup } from './components/LivePopup';
export function App() {
  return <div className="min-h-screen bg-black font-sans selection:bg-brand selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StatsSection data-id="element-2" />
      <TestimonialsSection data-id="element-3" />
      <PainSolutionSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <Footer data-id="element-9" />
      <LivePopup data-id="element-10" />
    </div>;
}